import { createSlice } from "@reduxjs/toolkit";

export const headerSlice = createSlice({
  name: "header",
  initialState: {
    pageTitle: "Home",
    pageBgClass: "bg-[#FAFBFF]",
    newNotificationMessage: "",
    newNotificationStatus: 1
  },
  reducers: {
    setPageTitle: (state, action) => {
      state.pageTitle = action.payload.title;
    },
    setPageBgClass: (state, action) => {
      state.pageBgClass = action.payload;
    },
    removeNotificationMessage: (state, action) => {
      state.newNotificationMessage = ""
    },
    showNotification: (state, action) => {
      state.newNotificationMessage = action.payload.message
      state.newNotificationStatus = action.payload.status
    },
  },
});

export const { setPageTitle, setPageBgClass, removeNotificationMessage, showNotification } = headerSlice.actions;

export default headerSlice.reducer;
